/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Footer_OfficialInputs */

const en_wc_footer_official = /** @type {(inputs: Wc_Footer_OfficialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft resources`)
};

/**
* | output |
* | --- |
* | "WordCraft resources" |
*
* @param {Wc_Footer_OfficialInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_footer_official = /** @type {((inputs?: Wc_Footer_OfficialInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Footer_OfficialInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_footer_official(inputs)
});
export { wc_footer_official as "wc.footer.official" }